import ACTIONS from "../actions";
import { CHAT_ROOMS, ONLINE_STATUS } from "../../config/index";
const {
  DATA_LOADING,
  SET_AUTH_TOKENS,
  SET_USER_DATA,
  SET_ALL_CHATS,
  UPDATE_ALL_CHATS_LIST,
  SET_ALL_GROUP_CHATS,
  FILTER_CHATS,
  SET_ACTIVE_CHAT,
  UPDATE_ACTIVE_CHAT_DATA,
  UPDATE_ACTIVE_CHAT_LIST,
  UPDATE_ACTIVE_CHAT_USER,
  UPDATE_CHATS,
  ADD_WAITING_ROOM_PARTICIPANT_REQUESTS,
  UPDATE_WAITING_ROOM_PARTICIPANT_REQUESTS,
  CLEAR_EXPIRED_JOIN_REQUESTS,
  UPDATE_USER_ONLINE_STATUS,
  UPDATE_USER_BAN_STATUS_IN_ACTIVE_ROOM,
  UPDATE_USER_TOOLBOX_BAN_STATUS_IN_ACTIVE_ROOM,
  UPDATE_USER_MODERATORSHIP_STATUS_IN_ACTIVE_ROOM,
  UPDATE_USER_KICK_OUT_VOTE_IN_ACTIVE_ROOM,
  UPDATE_NEW_ROOM_PARTICIPANT_IN_ACTIVE_ROOM,
  UPDATE_DELETED_CHAT_MESSAGE,
  UPDATE_EDITED_CHAT_MESSAGE,
  UPDATE_MUTED_ROOM_PARTICIPANT_IN_ACTIVE_ROOM,
  UPDATE_MESSAGE_INTERACTION_IN_ACTIVE_ROOM,
  UPDATE_MESSAGE_TIPPING_IN_ACTIVE_ROOM,
  UPDATE_ROOM_TEAM_SCORE_IN_ACTIVE_ROOM,
  UPDATE_USER_DATA,
  UPDATE_EXPIRED_ACTIVE_CHAT,
  TOGGLE_ROOM_TOOLBOX,
  SET_ROOM_TOOLBOX_ENABILITY,
  MARK_ROOM_MESSAGES_READ,
  UPDATE_CHAT_PREF,
  REMOVE_CHAT,
  UPDATE_CHAT_ONLINE_STATUS,
  ADD_OPTIMISTIC_MESSAGE,
  CONFIRM_OPTIMISTIC_MESSAGE,
  FAIL_OPTIMISTIC_MESSAGE,
  UPDATE_OPTIMISTIC_IMAGE_SRC,
  KEEP_MESSAGE,
  UNKEEP_MESSAGE,
  EXPIRE_MESSAGES,
  ADD_BLOCKED_PERIOD_MESSAGE,
  ADD_SYSTEM_NOTICE,
} = ACTIONS;

export default function appReducer(state, action) {
  switch (action.type) {
    case DATA_LOADING:
      return {
        ...state,
        dataLoading: action.payload,
      };
    case SET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
      };
    case SET_AUTH_TOKENS:
      const { accessToken, refreshToken } = action.payload;

      if (accessToken) {
        localStorage.setItem("accessToken", accessToken);
      } else {
        localStorage.removeItem("accessToken");
      }

      if (refreshToken) {
        localStorage.setItem("refreshToken", refreshToken);
      } else {
        localStorage.removeItem("refreshToken");
      }

      return {
        ...state,
        ...action.payload,
      };
    case SET_ALL_GROUP_CHATS:
      return {
        ...state,
        allGroupChats: action.payload,
        groupChatLoading: false,
      };
    case SET_ALL_CHATS:
      const chatsPaginations = { ...action.payload };
      delete chatsPaginations.conversations;
      // Debug: log first chat to check structure
      if (action.payload.conversations?.length > 0) {
        console.log('SET_ALL_CHATS payload:', action.payload.conversations[0]);
      }
      // Ensure each conversation has unread_count
      const chatsWithUnread = (action.payload.conversations || []).map(chat => ({
        ...chat,
        unread_count: chat?.unread_count || 0,
      }));
      return {
        ...state,
        chats: chatsWithUnread,
        chatsPaginations,
        chatLoading: false,
      };
    case UPDATE_ALL_CHATS_LIST:
      const updatingChatsPaginations = { ...action.payload }
      delete updatingChatsPaginations.conversations;
      const updatedAllChats = [...state.chats, ...action.payload.conversations]
      return {
        ...state,
        chats: updatedAllChats,
        chatsPaginations: updatingChatsPaginations,
        chatLoading: false,
      };
    case FILTER_CHATS:
      return {
        ...state,
        filteredChats: action.payload.filteredChats,
        searchInProgress: action.payload.searchInProgress,
      };
    case SET_ACTIVE_CHAT: {
      const incomingChat = action.payload;
      const isSameChat = state.activeChat?.id?.toString() === incomingChat?.id?.toString();

      // Always use the freshest chat data from state.chats when available.
      // The chat object passed by the caller (e.g. a ChatListItem click) may be
      // a snapshot from a previous render; state.chats is kept current by
      // UPDATE_CHATS socket events, so it has the latest messages.
      // Fall back to incomingChat for new/temp chats (id: null) that aren't in state.chats yet.
      const freshChat = (incomingChat?.id
        ? state.chats.find(c => c.id?.toString() === incomingChat.id?.toString())
        : null) || incomingChat;

      const chatsWithReset = state.chats.map((chat) => {
        if (!isSameChat && incomingChat?.id && chat.id?.toString() === incomingChat.id?.toString()) {
          return { ...chat, unread_count: 0 };
        }
        return chat;
      });

      // For real chats (with an id), also reset unread_count on the activeChat object itself.
      // For empty/temp chats (id: null or {}), keep as-is so the "no active chat" guards work.
      const nextActiveChat = freshChat?.id ? { ...freshChat, unread_count: 0 } : freshChat;

      return {
        ...state,
        chats: chatsWithReset,
        activeChat: nextActiveChat,
        is_expired: false,
      };
    }
    case SET_ROOM_TOOLBOX_ENABILITY:
      return {
        ...state,
        roomToolbox: { ...state.roomToolbox, currentUserToolboxEnabled: action.payload },
      };
    case TOGGLE_ROOM_TOOLBOX:
      return {
        ...state,
        roomToolbox: { ...state.roomToolbox, isOpen: !state.roomToolbox.isOpen },
      };
    case UPDATE_EXPIRED_ACTIVE_CHAT:
      const activeChatRoomId = action.payload.room_id?.toString();
      if (activeChatRoomId !== state.activeChat.id?.toString()) {
        return state;
      }

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          is_expired: true
        },
      };
    case UPDATE_ACTIVE_CHAT_DATA:
      const updatingActiveChatData = { ...action.payload };
      const updatingActiveRoomId = updatingActiveChatData.room_id;

      if (updatingActiveRoomId !== state.activeChat.id?.toString()) {
        return state;
      }

      delete updatingActiveChatData.room_id;

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          ...updatingActiveChatData
        }
      };
    case UPDATE_ACTIVE_CHAT_LIST:
      const updatedActiveChatPagination = { ...action.payload };
      delete updatedActiveChatPagination.messages;

      // Merge old and new messages
      const currentMessages = state.activeChat?.messages || [];
      const allMessages = [...action.payload.messages, ...currentMessages];

      // Sort messages by date in ascending order (oldest to newest)
      const sortedMessages = allMessages.sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return dateA - dateB;
      });

      // Remove any duplicate messages by id
      const uniqueMessages = sortedMessages.filter((message, index, self) =>
        index === self.findIndex((m) => m.id === message.id)
      );

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          messages: uniqueMessages,
          pagination: updatedActiveChatPagination
        }
      };
    case UPDATE_USER_DATA:
      let updatedUserData = { ...action.payload };
      const updatingUserId = updatedUserData.id?.toString();

      let updatedVersionOfUserData10 = null;

      //Delete user id from data and just update the rest of the data passed
      delete updatedUserData.id;

      //Updating the user data, if current user id is logged in user
      if (updatingUserId?.toString() === state.userData?.id?.toString()) {
        updatedVersionOfUserData10 = { ...state.userData };
        updatedVersionOfUserData10 = {
          ...updatedVersionOfUserData10,
          ...updatedUserData,
        };
      }

      return {
        ...state,
        userData: updatedVersionOfUserData10 ?? state.userData,
      };
    case UPDATE_MESSAGE_INTERACTION_IN_ACTIVE_ROOM: {
      const updatingRoomId = action.payload.room_id?.toString();
      const updatingMessageId = action.payload.message_id?.toString();
      const updatingMessageInteraction = action.payload.extra;
      const reactorId = action.payload.user_id?.toString();
      const myId = state.userData?.id?.toString();
      const iAmTheReactor = reactorId === myId;

      let updatedVersionOfActiveChat = null;

      if (
        Object.keys(state.activeChat).length &&
        state.activeChat?.id?.toString() === updatingRoomId
      ) {
        updatedVersionOfActiveChat = { ...state.activeChat };
        updatedVersionOfActiveChat.messages =
          updatedVersionOfActiveChat.messages.map((message) => {
            if (message?.id?.toString() === updatingMessageId) {
              return {
                ...message,
                interaction: {
                  // Always update the shared counts for everyone
                  count: updatingMessageInteraction.count,
                  // Only update my_reaction if I am the one who reacted
                  my_reaction: iAmTheReactor
                    ? updatingMessageInteraction.my_reaction
                    : (message.interaction?.my_reaction || null),
                },
              };
            }
            return message;
          });
      }

      return {
        ...state,
        activeChat: updatedVersionOfActiveChat ?? state.activeChat,
      };
    }
    case UPDATE_MESSAGE_TIPPING_IN_ACTIVE_ROOM:
      //Update the active chat message interaction
      const isSocket = action.payload.isSocket;
      const updatingRoomId1 = action.payload.room_id?.toString();
      const updatingTippingUserId1 = action.payload.user_id?.toString();
      const updatingMessageId1 = action.payload.message_id?.toString();
      const updatingMessageOwnerId1 =
        action.payload.message_onwer_id?.toString();
      const updatingMessageTipping = action.payload.extra;

      let updatedVersionOfActiveChat9 = null;
      let updatedVersionOfUserData9 = null;

      //Updating active chat, if it exist
      if (
        Object.keys(state.activeChat).length &&
        state.activeChat?.id?.toString() === updatingRoomId1
      ) {
        updatedVersionOfActiveChat9 = { ...state.activeChat };
        updatedVersionOfActiveChat9.messages =
          updatedVersionOfActiveChat9.messages.map((message) => {
            if (message?.id?.toString() === updatingMessageId1) {
              return {
                ...message,
                tip_count: updatingMessageTipping.count,
              };
            }
            return message;
          });
      }

      //Add 1 coin to the user coin balance, if its the user that was tipped
      if (updatingMessageOwnerId1 === state.userData.id?.toString()) {
        updatedVersionOfUserData9 = { ...state.userData };
        const newUserAvailiableCoin =
          Number(updatedVersionOfUserData9.available_coins) + 1;

        updatedVersionOfUserData9 = {
          ...updatedVersionOfUserData9,
          available_coins: newUserAvailiableCoin,
        };
      }

      //Remove 1 coin from the tipping user's coing balance
      if (
        updatingTippingUserId1 === state.userData.id?.toString() &&
        !isSocket
      ) {
        updatedVersionOfUserData9 = { ...state.userData };
        const newUserAvailiableCoin =
          Number(updatedVersionOfUserData9.available_coins) - 1;

        updatedVersionOfUserData9 = {
          ...updatedVersionOfUserData9,
          available_coins: newUserAvailiableCoin,
        };
      }

      return {
        ...state,
        userData: updatedVersionOfUserData9 ?? state.userData,
        activeChat: updatedVersionOfActiveChat9 ?? state.activeChat,
      };
    case UPDATE_ROOM_TEAM_SCORE_IN_ACTIVE_ROOM:
      //Update the active chat message interaction
      const updatingRoomId2 = action.payload.room_id?.toString();
      const updatingRoomTeamId = action.payload.team_id?.toString();
      const newlyAddedScore = action.payload.added_score;
      const newlyRemovedScore = action.payload.removed_score;

      let updatedVersionOfActiveChat10 = null;

      //Updating active chat, if it exist
      if (
        Object.keys(state.activeChat).length &&
        state.activeChat?.id?.toString() === updatingRoomId2
      ) {
        updatedVersionOfActiveChat10 = { ...state.activeChat };
        updatedVersionOfActiveChat10.room_teams =
          updatedVersionOfActiveChat10?.room_teams.map((team) => {
            const initialRoomTeamScore = Number(team.score);
            const newUpdatedTeamScore = newlyAddedScore ? initialRoomTeamScore + newlyAddedScore : initialRoomTeamScore - newlyRemovedScore;
            if (team?.id?.toString() === updatingRoomTeamId) {
              return {
                ...team,
                score: newUpdatedTeamScore,
              };
            }
            return team;
          }) || [];
      }

      return {
        ...state,
        activeChat: updatedVersionOfActiveChat10 ?? state.activeChat,
      };
    case UPDATE_MUTED_ROOM_PARTICIPANT_IN_ACTIVE_ROOM:
      const updatedMutedActiveRoomParticipantIds = {
        ...state.mutedActiveRoomParticipantIds,
      };
      const participantIdToToggle = action.payload?.toString();

      // Check if the participant ID is already in the muted list
      const isParticipantMuted =
        updatedMutedActiveRoomParticipantIds[participantIdToToggle];

      if (isParticipantMuted) {
        delete updatedMutedActiveRoomParticipantIds[participantIdToToggle];
      } else {
        // If not muted, add the participant ID to the list
        updatedMutedActiveRoomParticipantIds[participantIdToToggle] =
          participantIdToToggle;
      }

      // Update the state with the updated muted participants list
      return {
        ...state,
        mutedActiveRoomParticipantIds: updatedMutedActiveRoomParticipantIds,
      };
    case UPDATE_USER_ONLINE_STATUS:
      const updatingOnlineStatus = action.payload.online_status;
      const updatingUserLastSeen = action.payload.last_seen;
      const updatedRoomParticipantsList =
        state.activeChat.room_participants?.map((participant) => {
          if (
            participant.id?.toString() === action.payload.user_id?.toString()
          ) {
            return {
              ...participant,
              last_seen: updatingUserLastSeen,
              is_online: updatingOnlineStatus === ONLINE_STATUS.ONLINE ? 1 : 0,
            };
          }
          return participant;
        }) || [];
      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          room_participants: updatedRoomParticipantsList,
        },
      };
    case UPDATE_CHAT_ONLINE_STATUS: {
      const { userId, is_online, last_seen } = action.payload;

      const patchParticipants = (participants) =>
        participants?.map((p) =>
          p.id?.toString() === userId?.toString()
            ? { ...p, is_online, last_seen }
            : p
        ) ?? participants;

      const updatedChatsWithOnlineStatus = state.chats.map((chat) =>
        chat?.room_participants
          ? { ...chat, room_participants: patchParticipants(chat.room_participants) }
          : chat
      );

      const updatedActiveChat =
        state.activeChat?.room_participants
          ? {
              ...state.activeChat,
              room_participants: patchParticipants(state.activeChat.room_participants),
            }
          : state.activeChat;

      return {
        ...state,
        chats: updatedChatsWithOnlineStatus,
        activeChat: updatedActiveChat,
      };
    }
    case UPDATE_ACTIVE_CHAT_USER:
      return {
        ...state,
        activeChat: {
          otherUser: action.payload,
        },
      };
    case UPDATE_DELETED_CHAT_MESSAGE: {
      const roomId6 = action.payload.room_id;
      const messageId6 = action.payload.message_id;

      // Mark as deleted — frontend shows "This message was deleted" placeholder (WhatsApp style)
      const updatedChats = state.chats.map(chat => {
        if (chat.id?.toString() === roomId6?.toString()) {
          return {
            ...chat,
            messages: chat.messages.map(message =>
              message.id?.toString() === messageId6?.toString()
                ? { ...message, is_deleted: true }
                : message
            ),
          };
        }
        return chat;
      });

      if (state.activeChat?.id?.toString() === roomId6?.toString()) {
        const updatedActiveChatMessages = (state.activeChat?.messages || []).map(message =>
          message.id?.toString() === messageId6?.toString()
            ? { ...message, is_deleted: true }
            : message
        );

        return {
          ...state,
          chats: updatedChats,
          activeChat: {
            ...state.activeChat,
            messages: updatedActiveChatMessages,
          }
        };
      }

      return {
        ...state,
        chats: updatedChats
      };
    }
    case UPDATE_EDITED_CHAT_MESSAGE: {
      const roomId7 = action.payload.room_id;
      const messageId7 = action.payload.message_id;
      const updatedMessage7 = action.payload.message;
      // is_edited comes from backend (persisted); true for both optimistic and socket updates
      const isEdited7 = action.payload.is_edited ?? true;

      const patchMsg = (msg) =>
        msg.id?.toString() === messageId7?.toString()
          ? { ...msg, message: updatedMessage7, is_edited: isEdited7 }
          : msg;

      const updatedChats7 = state.chats.map((chat) =>
        chat.id?.toString() === roomId7?.toString()
          ? { ...chat, messages: chat.messages.map(patchMsg) }
          : chat
      );

      const updatedActiveChat7 =
        state.activeChat?.id?.toString() === roomId7?.toString()
          ? { ...state.activeChat, messages: (state.activeChat.messages || []).map(patchMsg) }
          : state.activeChat;

      return { ...state, chats: updatedChats7, activeChat: updatedActiveChat7 };
    }
    case "DELETE_MESSAGE_FOR_ME": {
      // Mark as deleted for this user only — shows the same placeholder as delete-for-everyone.
      // The backend excludes it on next fetch via message_user_deletions; the placeholder
      // disappears only when the user clicks the X (which stores the ID in localStorage).
      const { roomId: dmRoomId, messageId: dmMsgId } = action.payload;
      const markDeleted = (msgs) => msgs.map(m =>
        m.id?.toString() === dmMsgId?.toString() ? { ...m, is_deleted_for_me: true } : m
      );
      const dmChats = state.chats.map(c =>
        c.id?.toString() === dmRoomId?.toString() ? { ...c, messages: markDeleted(c.messages) } : c
      );
      const dmActive = state.activeChat?.id?.toString() === dmRoomId?.toString()
        ? { ...state.activeChat, messages: markDeleted(state.activeChat.messages || []) }
        : state.activeChat;
      return { ...state, chats: dmChats, activeChat: dmActive };
    }
    case UPDATE_USER_BAN_STATUS_IN_ACTIVE_ROOM:
      const newIsBannedStatus = action.payload.is_banned;
      const updatingParticipantId2 = action.payload.user_id;
      const updatedRoomParticipants2 = state.activeChat.room_participants.map(
        (participant) => {
          if (
            participant.id?.toString() === updatingParticipantId2?.toString()
          ) {
            return { ...participant, is_banned: newIsBannedStatus };
          }
          return participant;
        }
      );

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          room_participants: updatedRoomParticipants2,
        },
      };
    case UPDATE_USER_TOOLBOX_BAN_STATUS_IN_ACTIVE_ROOM:
      const newIsToolboxBannedStatus = action.payload.is_toolbox_banned;
      const updatingParticipantId5 = action.payload.user_id;
      const updatedRoomParticipants6 = state.activeChat.room_participants.map(
        (participant) => {
          if (
            participant.id?.toString() === updatingParticipantId5?.toString()
          ) {
            return { ...participant, is_toolbox_banned: newIsToolboxBannedStatus };
          }
          return participant;
        }
      );

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          room_participants: updatedRoomParticipants6,
        },
      };
    case UPDATE_USER_MODERATORSHIP_STATUS_IN_ACTIVE_ROOM:
      const newIsAdminStatus = action.payload.is_admin;
      const updatingParticipantId4 = action.payload.user_id;
      const updatedRoomParticipants5 = state.activeChat.room_participants.map(
        (participant) => {
          if (
            participant.id?.toString() === updatingParticipantId4?.toString()
          ) {
            return { ...participant, is_admin: newIsAdminStatus };
          }
          return participant;
        }
      );

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          room_participants: updatedRoomParticipants5,
        },
      };
    case UPDATE_USER_KICK_OUT_VOTE_IN_ACTIVE_ROOM:
      const newKickOffCount = action.payload.kickout_count;
      const updatingParticipantId3 = action.payload.user_id;
      const updatedRoomParticipants3 = state.activeChat.room_participants.map(
        (participant) => {
          if (
            participant.id?.toString() === updatingParticipantId3?.toString()
          ) {
            return { ...participant, kickout_count: newKickOffCount };
          }
          return participant;
        }
      );

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          room_participants: updatedRoomParticipants3,
        },
      };
    case UPDATE_NEW_ROOM_PARTICIPANT_IN_ACTIVE_ROOM:
      const updatedRoomParticipants4 = state.activeChat.room_participants;
      updatedRoomParticipants4?.push(action.payload);

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          room_participants: updatedRoomParticipants4,
        },
      };
    case ADD_WAITING_ROOM_PARTICIPANT_REQUESTS:
      return {
        ...state,
        waitingRoomParticipantRequests: [
          ...state.waitingRoomParticipantRequests,
          action.payload,
        ],
      };
    case UPDATE_WAITING_ROOM_PARTICIPANT_REQUESTS:
      const removeItemFromWaitingList =
        state.waitingRoomParticipantRequests.filter(
          (item) => item.id?.toString() !== action.payload.id?.toString()
        );
      return {
        ...state,
        waitingRoomParticipantRequests: removeItemFromWaitingList,
      };
    case CLEAR_EXPIRED_JOIN_REQUESTS:
      // Remove all requests matching any {userId, roomId} pair from the auto-cancel list
      return {
        ...state,
        waitingRoomParticipantRequests: state.waitingRoomParticipantRequests.filter(
          (item) =>
            !action.payload.some(
              ({ userId, roomId }) =>
                item.otherUser?.id?.toString() === userId?.toString() &&
                item.room?.id?.toString() === roomId?.toString()
            )
        ),
      };
    case UPDATE_CHATS:
      const dataPassed = action.payload;
      const actualMessage = dataPassed.message;
      const roomType = dataPassed.type;
      const roomId = dataPassed.id;
      // When confirming an optimistic send, remove it atomically while inserting the real message
      const _tempIdToConfirm = dataPassed._tempIdToConfirm || null;
      const roomMetaDataExtraPayload = dataPassed.room_meta_data;
      const wasInitialRoomIdUsed = roomMetaDataExtraPayload?.was_initial_room_id_used;
      const previousSentRoomId = roomMetaDataExtraPayload?.previous_sent_room_id;
      const roomHasConnected = dataPassed.has_connected_before;
      // Always default to an empty array — system message payloads omit room_participants
      const initialRoomParticipants = dataPassed.room_participants || [];
      let updatedRoomParticipants = initialRoomParticipants;

      //Dont update user's message when current user is not the sender and sender is muted in active "group" room
      if (
        dataPassed.type === CHAT_ROOMS.TYPES.GROUP &&
        state.mutedActiveRoomParticipantIds[actualMessage.sender_id]
      ) {
        return state;
      }

      //Check if chat type is single and user is a participant
      const checkIfUserIsAParticipant = initialRoomParticipants.find(
        (participant) =>
          participant.id?.toString() === state.userData.id?.toString()
      );
      if (
        roomType === CHAT_ROOMS.TYPES.SINGLE &&
        roomHasConnected &&
        initialRoomParticipants.length &&
        !checkIfUserIsAParticipant
      ) {
        return state;
      }

      //Check if roomId was changed on the backend due to previous sent roomId already exists
      //And its for direct messages
      if (roomType === CHAT_ROOMS.TYPES.SINGLE && !wasInitialRoomIdUsed) {
        const chatIndex = state.chats.findIndex(
          (chat) => chat?.id?.toString() === previousSentRoomId?.toString()
        );

        if (chatIndex !== -1) {
          const patched = [...state.chats];
          patched[chatIndex] = { ...patched[chatIndex], id: roomId };
          state = { ...state, chats: patched };
        }
      }

      //This means I need to update our participants
      if (initialRoomParticipants.length <= 0) {
        const chatData = state.chats.find(
          (chat) => chat?.id?.toString() === roomId?.toString()
        );
        updatedRoomParticipants = chatData?.room_participants;
      }

      //Structure data to key into existing data on app context
      let updatedMsg = [];
      let newDataObj = {};

      //Check if user is on filtered chats
      if (state.filteredChats.success) {
        //Check room type before updating it, since its filtered
        if (roomType === CHAT_ROOMS.TYPES.SINGLE) {
          // If we have a room ID change, copy the messages from previous room ID to new room ID
          if (!wasInitialRoomIdUsed && previousSentRoomId) {
            const previousChatData = state.filteredChats.direct_chats[previousSentRoomId];
            if (previousChatData) {
              // Copy the chat data to the new room ID while keeping the old one
              state.filteredChats.direct_chats[roomId] = {
                ...previousChatData,
                id: roomId // Update the ID in the chat data
              };

              // Keep both entries synchronized instead of deleting
              state.filteredChats.direct_chats[previousSentRoomId] = {
                ...previousChatData,
                id: roomId
              };
            }
          }

          // Now proceed with updating messages for both IDs (filter optimistic if confirming)
          const filteredBaseMsgs = _tempIdToConfirm
            ? (state.filteredChats.direct_chats[roomId]?.messages || []).filter(m => m.id !== _tempIdToConfirm && m.tempId !== _tempIdToConfirm)
            : (state.filteredChats.direct_chats[roomId]?.messages || null);
          updatedMsg = state.filteredChats.direct_chats[roomId]
            ? [...(filteredBaseMsgs || []), actualMessage]
            : [actualMessage];

          // Update both entries with the new message
          if (previousSentRoomId && !wasInitialRoomIdUsed) {
            newDataObj[previousSentRoomId] = state.filteredChats.direct_chats[previousSentRoomId] && {
              ...state.filteredChats.direct_chats[previousSentRoomId],
              messages: updatedMsg,
            };
          }

          newDataObj[roomId] = state.filteredChats.direct_chats[roomId] && {
            ...state.filteredChats.direct_chats[roomId],
            messages: updatedMsg,
          };
        } else {
          updatedMsg = state.filteredChats.group_chats[dataPassed.id]
            ? [
              ...state.filteredChats.group_chats[dataPassed.id]?.messages,
              actualMessage,
            ]
            : [actualMessage];

          newDataObj[dataPassed.id] = state.filteredChats.group_chats[
            dataPassed.id
          ] && {
            ...state.filteredChats.group_chats[dataPassed.id],
            messages: updatedMsg,
          };
        }
      } else {
        //This happens when user is not filtering, and chats are available
        updatedMsg = state.chats[dataPassed.id]
          ? [...state.chats[dataPassed.id]?.messages, actualMessage]
          : [actualMessage];
        newDataObj[dataPassed.id] = state.chats[dataPassed.id]
          ? { ...state.chats[dataPassed.id], messages: updatedMsg }
          : dataPassed;
      }

      //If user is on the current chat the message was sent to
      // The previousSentRoomId fallback is sender-only: it handles the optimistic → confirmed
      // room-ID swap. The receiver never has a previousSentRoomId so don't apply it for them.
      const isSentByMe = actualMessage.sender_id?.toString() === state.userData?.id?.toString();
      const isActiveChat = state.activeChat?.id?.toString() === dataPassed.id?.toString() ||
        (isSentByMe && !wasInitialRoomIdUsed && (
          state.activeChat?.id?.toString() === previousSentRoomId?.toString() ||
          (!state.activeChat?.id && previousSentRoomId === null)
        ));

      if (isActiveChat) {
        //Check if user is on filtered chats
        if (state.filteredChats.success) {
          //Update for the chats first
          let updatedChatsInFilter, updatedChatIndexInFilter;

          //Check if room already exists in chats
          const checkRoomExistInChats = state.chats.find((chat) => {
            return chat.id?.toString() === roomId?.toString();
          });
          if (checkRoomExistInChats) {
            updatedChatsInFilter = state.chats.map((chat) => {
              if (chat.id === roomId) {
                return {
                  ...chat,
                  messages: [...chat.messages, actualMessage],
                };
              }
              return chat;
            });

            updatedChatIndexInFilter = updatedChatsInFilter.findIndex(
              (chat) => chat.id === roomId
            );
            const updatedChat = updatedChatsInFilter[updatedChatIndexInFilter];

            // Remove the updated room object from its current position
            updatedChatsInFilter.splice(updatedChatIndexInFilter, 1);

            // Prepend the updated room object to the beginning of the rooms array
            updatedChatsInFilter.unshift(updatedChat);
          } else {
            //Since its a new chat generated from filtered search, add to chat as new record
            const updatedDataPassed = {
              ...dataPassed,
              messages: [actualMessage],
            };
            delete updatedDataPassed.message;

            // Prepend the updated room object to the beginning of the rooms array
            updatedChatsInFilter = [updatedDataPassed, ...state.chats];
          }

          if (roomType === CHAT_ROOMS.TYPES.SINGLE) {
            return {
              ...state,
              chats: updatedChatsInFilter,
              filteredChats: {
                ...state.filteredChats,
                direct_chats: {
                  ...state.filteredChats.direct_chats,
                  ...newDataObj,
                },
              },
              activeChat: {
                ...state.activeChat,
                id: roomId,  // Update activeChat with the real room ID
                messages: updatedMsg,
                has_connected_before: true,  // Mark that we've connected
              },
            };
          } else {
            return {
              ...state,
              chats: updatedChatsInFilter,
              filteredChats: {
                ...state.filteredChats,
                group_chats: {
                  ...state.filteredChats.group_chats,
                  ...newDataObj,
                },
              },
              activeChat: {
                ...state.activeChat,
                messages: updatedMsg,
              },
            };
          }
        } else {
          //This means that room is already in the chat, and its not a new chat
          const updatedChats = state.chats.map((chat) => {
            if (chat?.id?.toString() === roomId?.toString()) {
              return {
                ...chat,
                messages: [...chat.messages, actualMessage],
                unread_count: 0, // User is actively viewing this chat — nothing is unread
              };
            }
            return chat;
          });

          const updatedChatIndex = updatedChats.findIndex(
            (chat) => chat?.id?.toString() === roomId?.toString()
          );

          if (updatedChatIndex === -1) {
            // First message to a brand-new user: the temp chat (id: null) was never
            // added to state.chats. Build the real chat entry and prepend it.
            // Prefer dataPassed.room_participants (full data from backend for new chats),
            // but fall back to activeChat.room_participants (set from the new-user picker)
            // when the backend returns empty participants (e.g. re-opened deleted chat).
            const resolvedParticipants = dataPassed.room_participants?.length > 0
              ? dataPassed.room_participants
              : (state.activeChat?.room_participants || []);
            const newChatData = { ...dataPassed, messages: [actualMessage], room_participants: resolvedParticipants };
            delete newChatData.message;
            updatedChats.unshift(newChatData);
          } else if (updatedChatIndex > 0) {
            // Move existing chat to top
            const updatedChat = updatedChats[updatedChatIndex];
            updatedChats.splice(updatedChatIndex, 1);
            updatedChats.unshift(updatedChat);
          }

          const isSentByMe = actualMessage.sender_id?.toString() === state.userData?.id?.toString();
          const isNewChatFirstMessage = !state.activeChat?.id && previousSentRoomId === null && isSentByMe;
          // Atomically remove the optimistic (if any) and append the confirmed real message
          const allActiveMsgs = state.activeChat?.messages || [];
          const optimisticMsg = _tempIdToConfirm
            ? allActiveMsgs.find(m => m.id === _tempIdToConfirm || m.tempId === _tempIdToConfirm)
            : null;
          const baseActiveMsgs = _tempIdToConfirm
            ? allActiveMsgs.filter(m => m.id !== _tempIdToConfirm && m.tempId !== _tempIdToConfirm)
            : allActiveMsgs;
          // Carry client-side send timestamp forward so edit eligibility ignores server timezone
          const confirmedMsg = optimisticMsg?.local_sent_at
            ? { ...actualMessage, local_sent_at: optimisticMsg.local_sent_at }
            : actualMessage;
          return {
            ...state,
            chats: updatedChats,
            activeChat: (state.activeChat?.id || isNewChatFirstMessage)
              ? {
                  ...state.activeChat,
                  id: roomId,
                  messages: [...baseActiveMsgs, confirmedMsg],
                  has_connected_before: true,
                }
              : state.activeChat,
          };
        }
      } else {
        // Message arrived for a chat that is NOT currently active — increment unread_count
        // Only count real messages from others; system notices (tip/keep/disappearing) don't count.
        const isCountable = !actualMessage.is_system &&
          !actualMessage.is_optimistic &&
          actualMessage.sender_id?.toString() !== state.userData?.id?.toString();

        let updatedChats = [];

        if (initialRoomParticipants.length <= 0) {
          let initialChats = [...state.chats];
          initialChats = initialChats.map((chat) => {
            if (chat?.id?.toString() === roomId?.toString()) {
              return {
                ...chat,
                messages: [...chat.messages, actualMessage],
                unread_count: isCountable ? (chat.unread_count || 0) + 1 : (chat.unread_count || 0),
              };
            }
            return chat;
          });
          // Move updated chat to top
          const idx = initialChats.findIndex((c) => c?.id?.toString() === roomId?.toString());
          if (idx > 0) {
            const [moved] = initialChats.splice(idx, 1);
            initialChats.unshift(moved);
          }
          updatedChats = initialChats;
        } else {
          const updatedChat = {
            ...dataPassed,
            room_participants: updatedRoomParticipants,
            messages: [actualMessage],
            unread_count: isCountable ? 1 : 0,
          };
          delete updatedChat.message;

          updatedChats = [updatedChat, ...state.chats];
        }

        return {
          ...state,
          chats: updatedChats,
        };
      }
    // Mark all sent messages in a room as read (is_read: 1) — triggered when other user reads them
    case MARK_ROOM_MESSAGES_READ: {
      const { roomId } = action.payload;
      const markRead = (msgs) => msgs.map((m) => ({ ...m, is_read: 1 }));

      const updatedChats = state.chats.map((chat) => {
        if (chat.id?.toString() === roomId?.toString()) {
          return { ...chat, messages: markRead(chat.messages) };
        }
        return chat;
      });

      const isActiveRoom = state.activeChat?.id?.toString() === roomId?.toString();
      return {
        ...state,
        chats: updatedChats,
        activeChat: isActiveRoom
          ? { ...state.activeChat, messages: markRead(state.activeChat?.messages || []) }
          : state.activeChat,
      };
    }

    case UPDATE_CHAT_PREF: {
      const { roomId, ...prefs } = action.payload;
      const updatedChats = state.chats.map((chat) =>
        chat.id?.toString() === roomId?.toString() ? { ...chat, ...prefs } : chat
      );
      const isActive = state.activeChat?.id?.toString() === roomId?.toString();
      return {
        ...state,
        chats: updatedChats,
        activeChat: isActive ? { ...state.activeChat, ...prefs } : state.activeChat,
      };
    }

    case REMOVE_CHAT: {
      const { roomId } = action.payload;
      return {
        ...state,
        chats: state.chats.filter((chat) => chat.id?.toString() !== roomId?.toString()),
        activeChat: state.activeChat?.id?.toString() === roomId?.toString() ? {} : state.activeChat,
      };
    }

    case KEEP_MESSAGE: {
      const { roomId: kmRoomId, messageId: kmMsgId } = action.payload;
      const keepMsg = msgs => msgs.map(m => m.id?.toString() === kmMsgId?.toString() ? { ...m, is_kept: 1, disappears_at: null } : m);
      return {
        ...state,
        chats: state.chats.map(c => c.id?.toString() === kmRoomId ? { ...c, messages: keepMsg(c.messages) } : c),
        activeChat: state.activeChat?.id?.toString() === kmRoomId ? { ...state.activeChat, messages: keepMsg(state.activeChat.messages || []) } : state.activeChat,
      };
    }

    case UNKEEP_MESSAGE: {
      const { roomId: ukRoomId, messageId: ukMsgId } = action.payload;
      const unkeepMsg = msgs => msgs.map(m => m.id?.toString() === ukMsgId?.toString() ? { ...m, is_kept: 0 } : m);
      return {
        ...state,
        chats: state.chats.map(c => c.id?.toString() === ukRoomId ? { ...c, messages: unkeepMsg(c.messages) } : c),
        activeChat: state.activeChat?.id?.toString() === ukRoomId ? { ...state.activeChat, messages: unkeepMsg(state.activeChat.messages || []) } : state.activeChat,
      };
    }

    case ADD_OPTIMISTIC_MESSAGE: {
      const { roomId: opRoomId, message: opMsg } = action.payload;
      const isActiveOp = state.activeChat?.id?.toString() === opRoomId?.toString();
      // Always update state.chats so the optimistic message is visible even when switching chat
      const opChats = state.chats.map(c =>
        c.id?.toString() === opRoomId?.toString()
          ? { ...c, messages: [...(c.messages || []), opMsg] }
          : c
      );
      return {
        ...state,
        chats: opChats,
        activeChat: isActiveOp
          ? { ...state.activeChat, messages: [...(state.activeChat.messages || []), opMsg] }
          : state.activeChat,
      };
    }

    case CONFIRM_OPTIMISTIC_MESSAGE: {
      const { roomId: coRoomId, tempId: coTempId } = action.payload;
      const removeOp = msgs => msgs.filter(m => m.id !== coTempId && m.tempId !== coTempId);
      return {
        ...state,
        chats: state.chats.map(c => c.id?.toString() === coRoomId ? { ...c, messages: removeOp(c.messages) } : c),
        activeChat: state.activeChat?.id?.toString() === coRoomId
          ? { ...state.activeChat, messages: removeOp(state.activeChat.messages || []) }
          : state.activeChat,
      };
    }

    case FAIL_OPTIMISTIC_MESSAGE: {
      const { roomId: foRoomId, tempId: foTempId } = action.payload;
      const failOp = msgs => msgs.map(m =>
        (m.id === foTempId || m.tempId === foTempId) ? { ...m, is_pending: false, is_failed: true } : m
      );
      return {
        ...state,
        activeChat: state.activeChat?.id?.toString() === foRoomId
          ? { ...state.activeChat, messages: failOp(state.activeChat.messages || []) }
          : state.activeChat,
      };
    }

    // Swaps the displayed src on an optimistic image message from the local blob to the
    // remote (Cloudinary) URL in-place, after the remote URL has been pre-loaded into the
    // browser cache. This makes the blob→Cloudinary transition invisible to the user.
    case UPDATE_OPTIMISTIC_IMAGE_SRC: {
      const { roomId: uoRoomId, tempId: uoTempId, message: uoMsg } = action.payload;
      const swapSrc = msgs => msgs.map(m =>
        (m.id === uoTempId || m.tempId === uoTempId)
          ? { ...m, message: uoMsg, local_preview_url: null }
          : m
      );
      return {
        ...state,
        activeChat: state.activeChat?.id?.toString() === uoRoomId?.toString()
          ? { ...state.activeChat, messages: swapSrc(state.activeChat.messages || []) }
          : state.activeChat,
      };
    }

    case ADD_BLOCKED_PERIOD_MESSAGE: {
      const { roomId: bpRoomId, message: bpMsg, tempId: bpTempId } = action.payload;
      // Persist to localStorage so blocked messages survive page reload
      try {
        const stored = JSON.parse(localStorage.getItem("blocked_period_messages") || "{}");
        stored[bpRoomId] = [...(stored[bpRoomId] || []), bpMsg];
        localStorage.setItem("blocked_period_messages", JSON.stringify(stored));
      } catch (_) {}
      const isActiveRoom = state.activeChat?.id?.toString() === bpRoomId?.toString();
      if (!isActiveRoom) return state;
      // Atomically remove the optimistic message (if tempId provided) and add the blocked one
      const baseMessages = bpTempId
        ? (state.activeChat.messages || []).filter(m => m.id !== bpTempId && m.tempId !== bpTempId)
        : (state.activeChat.messages || []);
      return {
        ...state,
        activeChat: { ...state.activeChat, messages: [...baseMessages, bpMsg] },
      };
    }

    case ADD_SYSTEM_NOTICE: {
      const { roomId: noticeRoomId, text: noticeText } = action.payload;
      const noticeMsg = {
        id: `notice_${Date.now()}`,
        is_system: true,
        message: noticeText,
        created_at: Date.now(),
      };
      const isActiveRoom = state.activeChat?.id?.toString() === noticeRoomId?.toString();
      return {
        ...state,
        activeChat: isActiveRoom
          ? { ...state.activeChat, messages: [...(state.activeChat.messages || []), noticeMsg] }
          : state.activeChat,
      };
    }

    case EXPIRE_MESSAGES: {
      // Silently remove expired messages — no "deleted" placeholder, they just clear
      const { roomId: expRoomId, messageIds } = action.payload;
      const expRoomIdStr = expRoomId?.toString();
      const idSet = new Set(messageIds.map(String));
      const removeExpired = msgs => msgs.filter(m => !idSet.has(String(m.id)));
      const updatedChats = state.chats.map(chat =>
        chat.id?.toString() === expRoomIdStr
          ? { ...chat, messages: removeExpired(chat.messages) }
          : chat
      );
      const isActive = state.activeChat?.id?.toString() === expRoomIdStr;
      return {
        ...state,
        chats: updatedChats,
        activeChat: isActive
          ? { ...state.activeChat, messages: removeExpired(state.activeChat.messages || []) }
          : state.activeChat,
      };
    }

    default:
      return state;
  }
}
